module.exports = __webpack_public_path__ + "static/Testimonial-3302ef74e40648b8d1cc8379b38ba0b3.mp4";